/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { capitalize } from '@ember/string';
import SqlImportModel from 'cio/models/sql-import';

interface SqlImportsImportSummaryArgs {
  model: SqlImportModel;
  capitalize: boolean;
  progressive: boolean;
}

export default class SqlImportsImportSummary extends Component<SqlImportsImportSummaryArgs> {
  get addText() {
    return this.args.capitalize ? capitalize(this.verbs.add) : this.verbs.add;
  }

  get updateText() {
    return this.verbs.update;
  }

  get clearEmptyCellsText() {
    if (this.args.model.clearEmptyCells) {
      return 'Ignore empty values';
    }

    return 'Delete existing attribute value for empty value';
  }

  get ignoreSuppressText() {
    if (this.args.model.ignoreSuppressErr) {
      return 'Ignore suppressed people and mark successful';
    }

    return 'Ignore suppressed people and mark unsuccessful';
  }

  private get verbs() {
    let { progressive } = this.args;

    return {
      add: progressive ? 'adding' : 'add',
      update: progressive ? 'updating' : 'update',
    };
  }
}
